import { jsx as l } from "react/jsx-runtime";
const r = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M11.905 5.155 13.42 3.64l-.445-1.665-2.515 2.51a7.407 7.407 0 0 0-2.455-.42c-2.72 0-5.185 1.505-7 3.94.89 1.195 1.94 2.165 3.095 2.845l-1.515 1.515.45 1.675 2.515-2.515c.785.275 1.61.42 2.455.42 2.72 0 5.185-1.505 7-3.94-.89-1.195-1.94-2.165-3.095-2.845l-.005-.005ZM2.95 8C4.42 6.42 6.185 5.56 8 5.56c.415 0 .83.05 1.24.14l-.465.465c-.725-.29-1.615-.15-2.185.42a2.01 2.01 0 0 0-.425 2.195l-.955.955c-.8-.41-1.56-.99-2.255-1.735H2.95ZM8 10.44c-.415 0-.83-.05-1.24-.14l4.035-4.035c.8.41 1.56.99 2.255 1.735-1.47 1.58-3.235 2.44-5.05 2.44Z"
      }
    )
  }
);
export {
  r as Hide
};
